import { createFileRoute, Outlet } from '@tanstack/react-router';

import Layout from '@/screens/settings/layout';

export const Route = createFileRoute('/_app/settings')({
  component: LayoutRoute,
});

function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
